"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceList_1 = __importDefault(require("../ResourceList"));
const Sums_1 = __importStar(require("./Sums"));
const Witness_1 = __importDefault(require("../models/Witness"));
class Witnesses {
    constructor(client, hotspot, type = 'witnesses') {
        this.client = client;
        this.hotspot = hotspot;
        this.type = type;
    }
    async list(params = {}) {
        const url = `/hotspots/${this.hotspot.address}/${this.type}`;
        const { data: { data: witnesses, cursor }, } = await this.client.get(url, { cursor: params.cursor });
        const data = witnesses.map((witness) => new Witness_1.default(this.client, witness));
        return new ResourceList_1.default(data, this.list.bind(this), cursor);
    }
    get sum() {
        return new Sums_1.default(this.client, Sums_1.SumsType.witnesses, this.hotspot);
    }
}
exports.default = Witnesses;
//# sourceMappingURL=Witnesses.js.map